import React from 'react'

/**
 * 进程过度图标
 */
export const ArrowIcon = (): JSX.Element => (
  <svg width="15px" height="14px" viewBox="0 0 15 14" fill="currentColor">
    <g transform="translate(-499.000000, -470.000000)">
      <g transform="translate(506.000000, 477.000000) scale(-1, 1) translate(-506.000000, -477.000000) translate(498.000000, 469.000000)">
        <rect fill="#000000" opacity="0" x="0" y="0" width="16" height="16"></rect>
        <path d="M7.56368,12.51656 C7.89024,12.84312 7.89024,13.37288 7.56368,13.69944 C7.23712,14.02616 6.70752,14.02616 6.3808,13.69944 L1.2448,8.5636 C1.0816,8.40024 1,8.18632 1,7.97224 C1,7.75816 1.08176,7.54408 1.2448,7.38088 L6.3808,2.24504 C6.70752,1.91832 7.23712,1.91832 7.56368,2.24504 C7.89024,2.5716 7.89024,3.1012 7.56368,3.42792 L3.01936,7.97224 L7.56368,12.51656 Z M9.22592,7.97224 L13.77024,3.42792 C14.0968,3.1012 14.0968,2.5716 13.77024,2.24504 C13.44368,1.91832 12.91408,1.91832 12.58736,2.24504 L7.45136,7.38088 C7.28816,7.54424 7.20656,7.75816 7.20656,7.97224 C7.20656,8.18632 7.28832,8.4004 7.45136,8.5636 L12.58736,13.69944 C12.91408,14.02616 13.44368,14.02616 13.77024,13.69944 C14.0968,13.37288 14.0968,12.84312 13.77024,12.51656 L9.22592,7.97224 Z" stroke="#6791FF" fill="#6791FF"></path>
      </g>
    </g>
  </svg>
)
